import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/api";

const LINKS = [
  { id: "chi-siamo", label: "Il Lab" },
];

export const Navbar = () => {
  const [menu, setMenu] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setMenu(false);
  }, [pathname]);

  const go = (id) => {
    setMenu(false);
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 400);
    } else scrollToId(id);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-[rgba(152,191,162,0.12)] bg-[#050807]/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-5 md:px-10">
        <Link to="/" data-testid="nav-home-link"><Logo /></Link>
        <nav className="hidden items-center gap-6 xl:flex">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`nav-${l.id}-link`} onClick={() => go(l.id)}
              className="font-mono text-xs uppercase tracking-[0.14em] whitespace-nowrap text-[#a3b1aa] transition-colors hover:text-[#c4dcca]">
              {l.label}
            </button>
          ))}
          <Link to="/chi-sono" data-testid="nav-chi-sono-link" className="font-mono text-xs uppercase tracking-[0.14em] whitespace-nowrap text-[#a3b1aa] transition-colors hover:text-[#c4dcca]">Chi sono</Link>
          <Link to="/lifestyle-training" data-testid="nav-lifestyle-link" className="font-mono text-xs uppercase tracking-[0.14em] whitespace-nowrap text-[#a3b1aa] transition-colors hover:text-[#c4dcca]">Lifestyle Training</Link>
          <Link to="/training-online" data-testid="nav-coaching-link" className="font-mono text-xs uppercase tracking-[0.14em] whitespace-nowrap text-[#a3b1aa] transition-colors hover:text-[#c4dcca]">Training Online</Link>
          <Link to="/testimonianze" data-testid="nav-testimonianze-link" className="font-mono text-xs uppercase tracking-[0.14em] whitespace-nowrap text-[#a3b1aa] transition-colors hover:text-[#c4dcca]">Testimonianze</Link>
        </nav>
        <div className="flex items-center gap-2">
          <button data-testid="mobile-menu-toggle" onClick={() => setMenu((v) => !v)} className="grid h-10 w-10 place-items-center xl:hidden" aria-label="Menu">
            {menu ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {menu && (
          <motion.nav initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }} className="overflow-hidden border-t border-[rgba(152,191,162,0.12)] xl:hidden">
            {LINKS.map((l) => (
              <button key={l.id} data-testid={`mobile-nav-${l.id}-link`} onClick={() => go(l.id)}
                className="block w-full px-5 py-4 text-left font-display text-3xl font-800 uppercase">
                {l.label}
              </button>
            ))}
            <Link to="/chi-sono" data-testid="mobile-nav-chi-sono-link" className="block w-full px-5 py-4 text-left font-display text-3xl font-800 uppercase">Chi sono</Link>
            <Link to="/lifestyle-training" data-testid="mobile-nav-lifestyle-link" className="block w-full px-5 py-4 text-left font-display text-3xl font-800 uppercase">Lifestyle Training</Link>
            <Link to="/training-online" data-testid="mobile-nav-coaching-link" className="block w-full px-5 py-4 text-left font-display text-3xl font-800 uppercase">Training Online</Link>
            <Link to="/testimonianze" data-testid="mobile-nav-testimonianze-link" className="block w-full px-5 py-4 text-left font-display text-3xl font-800 uppercase">Testimonianze</Link>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
